export type Pair = [string, string];

export interface Word {
  w: string;
  pos: string;
  lv: string;
  parts: Pair[];
  ans: string;
  pts: string[];
  miss: string[];
  fam: Pair[];
  note?: string;
  tip?: string;
  custom?: boolean;
  level?: number | null;
}

export const WORDS: Word[] = [
  {w:"benevolent",pos:"adj.",lv:"進階",parts:[["bene","好、善"],["vol","想要、意願"],["ent","…的"]],
   ans:"仁慈的；樂善好施的",pts:["好、善意","出於自己的意願","對別人表現出來"],miss:["有錢的","好運的"],
   fam:[["benefit","好處、利益"],["benefactor","捐助者"],["volunteer","志願者"],["malevolent","惡意的"]]},
  {w:"transport",pos:"v. / n.",lv:"入門",parts:[["trans","跨越、到另一邊"],["port","搬運、攜帶"]],
   ans:"運輸；運送",pts:["從一處到另一處","搬運人或東西"],miss:["港口","護照"],
   fam:[["import","進口"],["export","出口"],["portable","可攜帶的"],["transfer","轉移"]]},
  {w:"incredible",pos:"adj.",lv:"入門",parts:[["in","不"],["cred","相信"],["ible","能被…的"]],
   ans:"難以置信的；驚人的",pts:["不能、很難","相信"],miss:["沒有信用的"],
   fam:[["credit","信用"],["credible","可信的"],["credential","資格證明"],["creed","信條"]]},
  {w:"malnutrition",pos:"n.",lv:"進階",parts:[["mal","壞、不良"],["nutri","滋養、餵養"],["tion","（名詞）"]],
   ans:"營養不良",pts:["不好、不足","營養"],miss:["食物中毒"],
   fam:[["malfunction","故障"],["malpractice","醫療疏失"],["nutrient","營養素"],["nutritious","有營養的"]]},
  {w:"audible",pos:"adj.",lv:"入門",parts:[["aud","聽"],["ible","能被…的"]],
   ans:"聽得見的",pts:["聽","能夠被"],miss:["觀眾"],
   fam:[["audience","聽眾、觀眾"],["audio","音訊"],["audition","試鏡、試聽"],["auditorium","禮堂"]]},
  {w:"contradict",pos:"v.",lv:"進階",parts:[["contra","相反、對立"],["dict","說"]],
   ans:"反駁；與…相矛盾",pts:["相反、對立","說出來"],miss:["合約"],
   fam:[["dictate","口述、命令"],["predict","預測"],["contrary","相反的"],["dictionary","字典"]]},
  {w:"inspect",pos:"v.",lv:"入門",parts:[["in","往裡面"],["spect","看"]],
   ans:"檢查；仔細查看",pts:["看","往裡、仔細"],miss:["昆蟲"],
   fam:[["spectator","觀眾"],["respect","尊敬"],["prospect","前景"],["spectacle","奇觀"]]},
  {w:"biography",pos:"n.",lv:"入門",parts:[["bio","生命"],["graph","寫、記錄"],["y","（名詞）"]],
   ans:"傳記",pts:["一個人的一生","寫下來"],miss:["生物學"],
   fam:[["autobiography","自傳"],["biology","生物學"],["photograph","照片"],["calligraphy","書法"]]},
  {w:"submarine",pos:"n.",lv:"入門",parts:[["sub","在下面"],["mar","海"],["ine","…的"]],
   ans:"潛水艇（形容詞：海底的）",pts:["在下面","海"],miss:["地鐵"],
   fam:[["subway","地鐵"],["submerge","沉入水中"],["marine","海洋的"],["maritime","航海的"]]},
  {w:"telescope",pos:"n.",lv:"入門",parts:[["tele","遠"],["scope","看、觀察的器具"]],
   ans:"望遠鏡",pts:["遠","看"],miss:["電視"],
   fam:[["telephone","電話"],["television","電視"],["microscope","顯微鏡"],["periscope","潛望鏡"]]},
  {w:"eject",pos:"v.",lv:"進階",parts:[["e","向外"],["ject","丟、投擲"]],
   ans:"彈出；逐出",pts:["向外","丟出去"],miss:["注射"],
   fam:[["inject","注射"],["reject","拒絕"],["project","投射；計畫"],["projectile","拋射物"]]},
  {w:"dehydrate",pos:"v.",lv:"進階",parts:[["de","去除"],["hydr","水"],["ate","使…"]],
   ans:"使脫水；（身體）缺水",pts:["去除","水"],miss:["補充水分"],
   fam:[["hydrant","消防栓"],["hydrogen","氫"],["hydropower","水力發電"],["decode","解碼"]]},
  {w:"omnivore",pos:"n.",lv:"進階",parts:[["omni","全部"],["vor","吃、吞"],["e","（名詞）"]],
   ans:"雜食動物",pts:["全部、什麼都","吃","指動物"],miss:["全能的人"],
   fam:[["carnivore","肉食動物"],["herbivore","草食動物"],["voracious","貪吃的"],["omnipresent","無所不在的"]]},
  {w:"philanthropy",pos:"n.",lv:"挑戰",parts:[["phil","愛"],["anthrop","人類"],["y","（名詞）"]],
   ans:"慈善事業；博愛",pts:["愛","人類","用行動或捐款幫助人"],miss:["集郵","哲學"],
   fam:[["philosophy","哲學（愛智慧）"],["anthropology","人類學"],["misanthrope","厭惡人類的人"],["bibliophile","愛書人"]]},
  {w:"circumnavigate",pos:"v.",lv:"挑戰",parts:[["circum","環繞"],["navig","航行"],["ate","（動詞）"]],
   ans:"環航；繞著…航行一圈",pts:["繞一圈","航行"],miss:["規避"],
   fam:[["circumference","圓周"],["circumstance","情況"],["navigate","航行、導航"],["naval","海軍的"]]},
  {w:"retrospect",pos:"n.",lv:"進階",parts:[["retro","往回、向後"],["spect","看"]],
   ans:"回顧；回想",pts:["往回、過去","看"],miss:["檢查"],
   fam:[["retroactive","追溯既往的"],["introspect","自省"],["prospect","前景"],["inspect","檢查"]]},
  {w:"unanimous",pos:"adj.",lv:"挑戰",parts:[["un","一（uni）"],["anim","心、精神"],["ous","…的"]],
   ans:"一致同意的",pts:["一、同一個","心意","所有人都"],miss:["匿名的"],
   note:"很多人會跟 anonymous（匿名的）搞混，兩個字的字根完全不同。",
   fam:[["uniform","制服（同一形式）"],["unify","統一"],["animate","使有生氣"],["equanimity","沉著"]]},
  {w:"chronology",pos:"n.",lv:"進階",parts:[["chrono","時間"],["logy","學問、論述"]],
   ans:"年表；事件的時間順序",pts:["時間","排列、整理"],miss:["慢性病"],
   fam:[["chronic","慢性的"],["synchronize","同步"],["anachronism","時代錯置"],["biology","生物學"]]},
  {w:"pedestrian",pos:"n. / adj.",lv:"進階",parts:[["ped","腳"],["estr","…的"],["ian","人"]],
   ans:"行人（形容詞：平淡無奇的）",pts:["腳","走路的人"],miss:["小孩","兒科"],
   note:"ped（腳，拉丁文）和 pediatric 的 ped（兒童，希臘文）長得一樣，來源不同。",
   fam:[["pedal","踏板"],["pedicure","修腳"],["centipede","蜈蚣（百足）"],["biped","雙足動物"]]},
  {w:"antibiotic",pos:"n.",lv:"入門",parts:[["anti","對抗"],["bio","生命"],["tic","…的"]],
   ans:"抗生素",pts:["對抗","生命（細菌）","藥物"],miss:["反對生物學"],
   fam:[["antibody","抗體"],["antisocial","反社會的"],["biotic","生物的"],["biology","生物學"]]},
  {w:"verdict",pos:"n.",lv:"進階",parts:[["ver","真實"],["dict","說"]],
   ans:"判決；裁定",pts:["真實","說出來","正式的結論"],miss:["綠色的"],
   fam:[["verify","證實"],["veracity","誠實"],["predict","預測"],["dictate","口述、命令"]]},
  {w:"manuscript",pos:"n.",lv:"入門",parts:[["manu","手"],["script","寫"]],
   ans:"手稿；原稿",pts:["手","寫"],miss:["說明書"],
   fam:[["manual","手動的；手冊"],["manufacture","製造"],["describe","描述"],["postscript","附筆（P.S.）"]]},
  {w:"insomnia",pos:"n.",lv:"進階",parts:[["in","沒有"],["somn","睡眠"],["ia","病症"]],
   ans:"失眠",pts:["沒有、不能","睡眠"],miss:["室內"],
   fam:[["somnambulism","夢遊"],["somnolent","昏昏欲睡的"],["anemia","貧血"],["amnesia","失憶"]]},
  {w:"sympathy",pos:"n.",lv:"入門",parts:[["sym","一起"],["path","感受、痛苦"],["y","（名詞）"]],
   ans:"同情；同感",pts:["一起","感受"],miss:["交響樂"],
   fam:[["empathy","同理心"],["apathy","冷漠"],["telepathy","心電感應"],["symphony","交響樂"]]}
];

const TIPS: Record<string, string> = {
  benevolent:"bene 好＋vol 想要：心裡想要對人好，就是仁慈。換成 mal 壞，malevolent 就是「想要使壞」。",
  transport:"port 搬運，想成港口 port：貨從一個港口搬到 trans 另一邊，就是運輸。",
  incredible:"credit card 是銀行「相信」你會還錢；in 不＋cred 相信，就是讓人不敢相信的。",
  malnutrition:"mal 壞，跟 malware（惡意軟體）同一個 mal；營養變壞了，就是營養不良。",
  audible:"audio、audience 都跟「聽」有關，加上 -ible（能被…的），就是聽得見的。",
  contradict:"dictionary 是收集「說法」的書；contra 反著說，就是反駁、互相矛盾。",
  inspect:"spect 看，跟 spectator（看比賽的人）一樣；往裡面仔細看，就是檢查。",
  biography:"bio 生命＋graph 寫：把一個人的一生寫下來。前面再加 auto（自己）就是自傳。",
  submarine:"sub 下面，像 subway 地下鐵；mar 海，像 marine 海軍陸戰隊。在海面下跑的就是潛水艇。",
  telescope:"tele 遠，像 telephone（遠方的聲音）；scope 看。用來看遠方的，就是望遠鏡。",
  eject:"ject 丟，想 projector 投影機把畫面丟到牆上；e 往外丟，戰鬥機的彈射座椅就叫 ejection seat。",
  dehydrate:"hydr 水，消防栓 hydrant 就是噴水的；de 把水拿掉，就是脫水。",
  omnivore:"omni 全部（omnipresent 無所不在）＋vor 吃（voracious 貪吃）：什麼都吃，就是雜食動物。",
  philanthropy:"phil 愛，費城 Philadelphia 叫「兄弟之愛之城」；anthrop 人類。愛人類、捐錢幫人，就是慈善。",
  circumnavigate:"circum 繞圈，聽起來像 circle；navigate 是導航、航行。繞地球航行一圈，就是環航。",
  retrospect:"retro 復古風就是「往回」；spect 看。回頭看過去，就是回顧。",
  unanimous:"uni 一，像 unicorn 獨角獸；anim 心，像 animal（有靈魂的生物）。大家一條心，就是全體一致。別跟 anonymous（沒有名字，匿名）搞混。",
  chronology:"chron 時間，chronic 慢性病就是拖很久的病；-logy 整理成學問。把事情依時間整理，就是年表。",
  pedestrian:"ped 腳，腳踏車的踏板叫 pedal；用腳走路的人，就是行人。",
  antibiotic:"anti 對抗＋bio 生命：對抗細菌這種小生命的藥，就是抗生素。",
  verdict:"ver 真實，像 verify 驗證；dict 說。法官說出真相，就是判決。",
  manuscript:"manu 手，像 manual 手動；script 寫。用手寫出來的稿，就是手稿。",
  insomnia:"somn 睡，somnambulism（睡著走路）就是夢遊；in 沒有＋somn 睡眠，就是失眠。",
  sympathy:"sym 一起，像 symphony（聲音一起響）；path 感受。跟你一起感受，就是同情。"
};
for (const x of WORDS) x.tip = TIPS[x.w] ?? "";

export const BUILTIN = new Map(WORDS.map(x => [x.w, x]));

/** 引導的方向標籤。 */
export const TAGS = {
  hit: "答對了",
  close: "很接近了",
  half: "抓到一半",
  vague: "太籠統",
  narrow: "太窄了",
  wrong: "方向不對",
} as const;
export type Tag = keyof typeof TAGS;
export const TAG_KEYS = Object.keys(TAGS) as [Tag, ...Tag[]];

/** 大考中心 7000 單字的級數對應到難度標籤。 */
export const lvOf = (level: number | null | undefined) =>
  level == null ? null : level <= 3 ? "入門" : level <= 5 ? "進階" : "挑戰";

export const WORD_RE = /^[a-z][a-z-]{1,38}$/;
